export const GET_LINKED_FASTAG_START = 'fastag/GET_LINKED_FASTAG_START';
export const GET_LINKED_FASTAG_REQUEST = 'fastag/GET_LINKED_FASTAG_REQUEST';
export const GET_LINKED_FASTAG_SUCCESS = 'fastag/GET_LINKED_FASTAG_SUCCESS';
export const GET_LINKED_FASTAG_FAILURE = 'fastag/GET_LINKED_FASTAG_FAILURE';
export const GET_LINKED_FASTAG_RESET = 'fastag/GET_LINKED_FASTAG_RESET';

export const UPDATE_STATUS_POPUP = 'fastag/UPDATE_STATUS_POPUP';

export const UPDATE_USER_VEHICLE_FASTAGS = 'fastag/UPDATE_USER_VEHICLE_FASTAGS';
export const UPDATE_USER_VEHICLE = 'fastag/UPDATE_USER_VEHICLE';
